import styled from 'styled-components';

export const hubNotice = styled.div`
    margin: 0 0 20px;
    padding: 12px 16px;
    border-radius: 8px;
    background: #f5f8ff;
    color: #333;
    font-size: 14px;
    line-height: 1.5;
`;
